import { formatMessage } from 'devextreme/localization';
import { Field } from 'devextreme/ui/pivot_grid/data_source';

export const year: Field = {
  name: 'year',
  caption: 'year',
  dataField: 'date',
  dataType: 'date',
  groupInterval: 'year',
  allowFiltering: false,
  isMeasure: false,
};

export const year_filter: Field = {
  ...year,
  area: 'filter',
};

export const year_row: Field = {
  ...year,
  area: 'row',
};

export const year_row_expanded: Field = {
  ...year,
  area: 'row',
  expanded: true,
};

export const year_column: Field = {
  ...year,
  area: 'column',
};

export const year_column_expanded: Field = {
  ...year,
  area: 'column',
  expanded: true,
};

export const halfYear: Field = {
  name: 'halfYear',
  caption: 'halfYear',
  dataField: 'date',
  dataType: 'date',
  selector: (date: any) => {
    return formatMessage(`HY${Math.ceil((new Date(date.date).getMonth() + 1) / 3) < 3 ? 1 : 2}`);
  },
  isMeasure: false,
};

export const halfYear_row: Field = {
  ...halfYear,
  area: 'row',
};

export const halfYear_row_expanded: Field = {
  ...halfYear,
  area: 'row',
  expanded: true,
};

export const halfYear_column: Field = {
  ...halfYear,
  area: 'column',
};

export const halfYear_column_expanded: Field = {
  ...halfYear,
  area: 'column',
  expanded: true,
};

export const quarter: Field = {
  name: 'quarter',
  caption: 'quarter',
  dataField: 'date',
  dataType: 'date',
  groupInterval: 'quarter',
  isMeasure: false,
};

export const quarter_row: Field = {
  ...quarter,
  area: 'row',
};

export const quarter_row_expanded: Field = {
  ...quarter,
  area: 'row',
  expanded: true,
};

export const quarter_column: Field = {
  ...quarter,
  area: 'column',
};

export const quarter_column_expanded: Field = {
  ...quarter,
  area: 'column',
  expanded: true,
};

export const month: Field = {
  name: 'month',
  caption: 'month',
  dataField: 'date',
  dataType: 'date',
  groupInterval: 'month',
  isMeasure: false,
};

export const month_filter: Field = {
  ...month,
  area: 'filter',
};

export const month_row: Field = {
  ...month,
  area: 'row',
};

export const month_row_expanded: Field = {
  ...month,
  area: 'row',
  expanded: true,
};

export const month_column: Field = {
  ...month,
  area: 'column',
};

export const month_column_expanded: Field = {
  ...month,
  area: 'column',
  expanded: true,
};

export const day: Field = {
  name: 'day',
  caption: 'day',
  dataField: 'date',
  dataType: 'date',
  groupInterval: 'day',
  isMeasure: false,
};

export const day_row: Field = {
  ...day,
  area: 'row',
};

export const day_row_expanded: Field = {
  ...day,
  area: 'row',
  expanded: true,
};

export const day_column: Field = {
  ...day,
  area: 'column',
};

export const day_column_expanded: Field = {
  ...day,
  area: 'column',
  expanded: true,
};
